import { combineReducers } from "@reduxjs/toolkit";

import interactiveMap from "./interactiveMap";
import lightbox from "./lightbox";
import modals from "./modals";

export default combineReducers({ interactiveMap, lightbox, modals });
